
import Vue from 'vue'
import JcdcLabeledTextPair from '@/components/jcdc/JcdcLabeledTextPair.vue'

export default Vue.extend({
  name: 'JcdcLabeledText',
  components: { JcdcLabeledTextPair },
  props: {
    items: {
      type: Object,
      required: true,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    alignValues: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    labelWidth(): number {
      const flattenedList = Object.keys(this.flattenObject(this.items)),
        longestLabel = flattenedList.reduce((a, b) => {
          return a.length > b.length ? a : b
        })
      return longestLabel.length + 1
    },
  },
  methods: {
    flattenObject(obj) {
      const flattened = {}
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          Object.assign(flattened, this.flattenObject(obj[key]))
        } else {
          flattened[key] = obj[key]
        }
      })
      return flattened
    },
  },
})
